import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'underscore'
import classNames from 'classnames'
import { injectIntl, FormattedMessage } from 'react-intl'
import HighlightedTextarea from './HighlightedTextarea'
import { charCountLimit } from './index'
import { checkIfEmpty } from '../../services/helpers'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'
import Loader from '../Loader'
import { updateEditDynamicDataState } from '../../actions/AspireEditDynamicData'
import { updateNewSamplesState } from '../../actions/AspireSamples'
import { editModalAriaLabel } from '../Constants/AriaLabelText'
import SelectPlus from 'react-select-plus'
import ThreeDotsButton from './HelperComponents/ThreeDotsButton'
import SaveBtn from './HelperComponents/SaveBtn'



class Education extends Component {


  constructor(props) {
    super(props)
    this.state = {
      selectedPresentCategory: '',
      focused: {
        school: false,
        to: false,
        from: false,
        degree: false,
        field_of_study: false,
        grade: false,
        activities_and_societies: false,
      },
      checkbox: {
        tense: false,
        narrative_voice: false,
        buzzwords: false,
        verb_overusage: false,
        action_oriented: false,
        specifics: false,
      },
      iimmumbaiExampleIndex: 0,
    }

    this.handleFocus = this.handleFocus.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.updateCheckboxState = this.updateCheckboxState.bind(this)
    this.handleUndoClick = this.handleUndoClick.bind(this)
    this.highlightValues = this.highlightValues.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.sendTrackingDataDebounceUndo = _.debounce(sendTrackingData, 3000, true)
    this.sendTrackingDataDebounceInfoModal = _.debounce(
      sendTrackingData,
      3000,
      true
    )
    this.activitiesAndSocietiesCharsRemaining =
      charCountLimit['education']['activities_and_societies']
    this.handleCloseButton = this.handleCloseButton.bind(this)
    this.setSelectedPresentCategory = this.setSelectedPresentCategory.bind(this)
    this.placeholders = {
      school: this.props.intl.formatMessage({ id: "aspire.education.enterSchool", defaultMessage: "Enter school" }),
      to: this.props.intl.formatMessage({ id: "aspire.education.endYear", defaultMessage: "End year" }),
      from: this.props.intl.formatMessage({ id: "aspire.education.startYear", defaultMessage: "Start year" }),
      degree: this.props.intl.formatMessage({ id: "aspire.education.enterDegree", defaultMessage: "Enter degree" }),
      field_of_study: this.props.intl.formatMessage({ id: "aspire.education.enterFieldOfStudy", defaultMessage: "Enter field of study" }),
      grade: this.props.intl.formatMessage({ id: "aspire.education.enterGrade", defaultMessage: "Enter grade" }),
      activities_and_societies: this.props.intl.formatMessage({ id: "aspire.education.enterActivitiesAndSocieties", defaultMessage: "Enter activities and societies" }),
    }
  }

  UNSAFE_componentWillMount() {
    let textValue =
      this.props.sectionWiseTextEditable[this.props.currentIndex][
        'activities_and_societies'
      ] === false
        ? ''
        : this.props.sectionWiseTextEditable[this.props.currentIndex][
            'activities_and_societies'
          ]
    this.activitiesAndSocietiesCharsRemaining =
      charCountLimit['education']['activities_and_societies'] - textValue.length
  }

  handleDateChange(option) {
    let value = option.value
    let name = option.name
    this.props.handleOnChangeData(
      'education',
      this.props.currentIndex,
      name,
      value
    )
    let fromYear = parseInt(
      this.props.sectionWiseTextEditable[this.props.currentIndex]['from']
    )
    if (
      name === 'to' &&
      !_.isEmpty(value) &&
      (isNaN(fromYear) || parseInt(value) < parseInt(fromYear))
    )
      this.props.handleOnChangeData(
        'education',
        this.props.currentIndex,
        'from',
        ''
      )
  }

  handleChange(e) {
    const value = e.target.value
    const name = e.target.name
    this.props.handleOnChangeData(
      'education',
      this.props.currentIndex,
      name,
      value
    )

    if (name == 'activities_and_societies') {
      let charsRemainingCount = -1
      if (
        charCountLimit.hasOwnProperty('education') &&
        charCountLimit['education'].hasOwnProperty('activities_and_societies')
      ) {
        charsRemainingCount =
          charCountLimit['education']['activities_and_societies'] - value.length
      }
      // if(charsRemainingCount < 0){
      //   charsRemainingCount = 0
      // }
      this.activitiesAndSocietiesCharsRemaining = charsRemainingCount
    }

    let fromYear = parseInt(
      this.props.sectionWiseTextEditable[this.props.currentIndex]['from']
    )

    if (
      name === 'to' &&
      !_.isEmpty(value) &&
      (isNaN(fromYear) || parseInt(value) < parseInt(fromYear))
    )
      this.props.handleOnChangeData(
        'education',
        this.props.currentIndex,
        'from',
        ''
      )
  }

  setSelectedPresentCategory(category) {
    this.setState({ selectedPresentCategory: category })
  }

  handleUndoClick() {
    const { currentIndex, sectionWiseTextStatic } = this.props

    let jsonObjectForTracking = {
      eventLabel: 'undo_changes_btn',
      currentSection: 'Education',
      currentIndex: currentIndex,
    }

    this.sendTrackingDataDebounceUndo(
      'event',
      'aspire_edit_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
    this.props.handleUndoData('education', this.props.currentIndex)
    let textValue =
      this.props.sectionWiseTextStatic[this.props.currentIndex][
        'activities_and_societies'
      ] === false
        ? ''
        : this.props.sectionWiseTextStatic[this.props.currentIndex][
            'activities_and_societies'
          ]
    this.activitiesAndSocietiesCharsRemaining =
      charCountLimit['education']['activities_and_societies'] - textValue.length
  }

  handleFocus(field, e) {
    e.preventDefault()
    let focused = this.state.focused

    for (let i in focused) {
      if (i == field) {
        focused[i] = true
      } else {
        focused[i] = false
      }
    }

    let checkbox = {
      tense: false,
      narrative_voice: false,
      buzzwords: false,
      verb_overusage: false,
      action_oriented: false,
      specifics: false,
    }

    this.setState({
      focused: focused,
      checkbox: checkbox,
      selectedPresentCategory: '',
    })
    setTimeout(() => {
      if ($('.as-edit-input-field-wrapper').find('input').length != 0) {
        $('.as-edit-input-field-wrapper').find('input')[0].focus()
      }
    }, 100)
  }

  handleBlur(field) {
    let focused = this.state.focused
    focused[field] = false
    this.setState({ focused: focused })
  }

  handleCloseButton() {
    const {
      handleUndoData,
      currentIndex,
      hideEditModal,
      sectionWiseTextEditable,
      sectionWiseTextStatic,
    } = this.props
    let jsonObjectForTracking = {
      eventLabel: 'close_btn',
      currentSection: 'Education',
      currentIndex: currentIndex,
    }
    sendTrackingData(
      'event',
      'aspire_edit_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
    hideEditModal(
      'education',
      currentIndex,
      sectionWiseTextEditable,
      sectionWiseTextStatic
    )
  }

  renderPlaceholder(text, field) {
    if (!_.isEmpty(text)) {
      return text
    }

    return <span className="placeholder-color">{this.placeholders[field]}</span>
  }

  updateCheckboxState(checkbox) {
    this.setState({ checkbox: checkbox })
  }

  highlightValues(input) {
    return this.props.highlightableDivWords
  }

  renderEntityText(entity) {
    const { savingChanges, intl } = this.props

    let fieldDisabled = false
    if (savingChanges) {
      fieldDisabled = true
    }

    if (this.state.focused[entity] == true) {
      if (entity == 'school') {
        return (
          <input
            type="text"
            className=""
            tabIndex={0}
            name="school"
            value={
              this.props.sectionWiseTextEditable[this.props.currentIndex][
                'school'
              ]
            }
            aria-label={editModalAriaLabel(intl)['Education']['input_school']}
            placeholder={this.placeholders['school']}
            onChange={(e) => this.handleChange(e)}
            onBlur={() => this.handleBlur('school')}
            disabled={fieldDisabled}
          />
        )
      } else if (entity == 'degree') {
        return (
          <input
            type="text"
            className=""
            tabIndex={0}
            name="degree"
            value={
              this.props.sectionWiseTextEditable[this.props.currentIndex][
                'degree'
              ]
            }
            aria-label={editModalAriaLabel(intl)['Education']['input_degree']}
            placeholder={this.placeholders['degree']}
            onChange={(e) => this.handleChange(e)}
            onBlur={() => this.handleBlur('degree')}
            disabled={fieldDisabled}
          />
        )
      } else if (entity == 'field_of_study') {
        return (
          <input
            type="text"
            className=""
            tabIndex={0}
            name="field_of_study"
            value={
              this.props.sectionWiseTextEditable[this.props.currentIndex][
                'field_of_study'
              ]
            }
            aria-label={editModalAriaLabel(intl)['Education']['input_field']}
            placeholder={this.placeholders['field_of_study']}
            onChange={(e) => this.handleChange(e)}
            onBlur={() => this.handleBlur('field_of_study')}
            disabled={fieldDisabled}
          />
        )
      }
    } else {
      if (entity == 'school') {
        return (
          <div
            className="education-entity-school entity-text as-input-div hide-scrollbar"
            tabIndex={0}
            role="textbox"
            aria-label="School"
            onMouseDown={(e) => this.handleFocus('school', e)}
            onFocus={(e) => this.handleFocus('school', e)}>
            {this.renderPlaceholder(
              this.props.sectionWiseTextEditable[this.props.currentIndex][
                'school'
              ],
              'school'
            )}
          </div>
        )
      } else if (entity == 'degree') {
        return (
          <div
            className="education-entity-degree entity-text as-input-div hide-scrollbar "
            tabIndex={0}
            role="textbox"
            aria-label={'Degree'}
            onMouseDown={(e) => this.handleFocus('degree', e)}
            onFocus={(e) => this.handleFocus('degree', e)}>
            {this.renderPlaceholder(
              this.props.sectionWiseTextEditable[this.props.currentIndex][
                'degree'
              ],
              'degree'
            )}
          </div>
        )
      } else if (entity == 'field_of_study') {
        return (
          <div
            className="education-entity-field_of_study entity-text as-input-div hide-scrollbar "
            tabIndex={0}
            role="textbox"
            aria-label={'Field of Study'}
            onMouseDown={(e) => this.handleFocus('field_of_study', e)}
            onFocus={(e) => this.handleFocus('field_of_study', e)}>
            {this.renderPlaceholder(
              this.props.sectionWiseTextEditable[this.props.currentIndex][
                'field_of_study'
              ],
              'field_of_study'
            )}
          </div>
        )
      }
    }

    if (entity == 'to') {
      let fromYear =
        this.props.sectionWiseTextEditable[this.props.currentIndex]['from']
      var startYear =
        fromYear === '' ? new Date().getFullYear() : parseInt(fromYear)
      var options = []
      for (var i = startYear + 10; i >= startYear; i--) {
        options.push({ value: '' + i, label: i, name: 'to' })
      }
      return (
        <SelectPlus
          className="as-edit-select-field"
          closeOnSelect={true}
          name="to"
          value={
            this.props.sectionWiseTextEditable[this.props.currentIndex]['to']
          }
          searchable={false}
          valueKey="value"
          arrowRenderer={() => {
            return null
          }}
          disabled={fromYear === ''}
          clearable={false}
          tabSelectsValue={false}
          placeholder={intl.formatMessage({ id: "aspire.education.toYearPlaceholder", defaultMessage: "End Year" })}
          aria-label={editModalAriaLabel(intl)['Education']['to_year']}
          options={options}
          onChange={this.handleDateChange}
        />
      )
    } else if (entity == 'from') {
      var startYear = new Date().getFullYear()
      var options = []
      for (var i = startYear; i >= startYear - 59; i--) {
        var year = i
        if (
          !_.isEmpty(
            this.props.sectionWiseTextEditable[this.props.currentIndex]['to']
          ) &&
          this.props.sectionWiseTextEditable[this.props.currentIndex]['to'] !=
            -1 &&
          year >
            this.props.sectionWiseTextEditable[this.props.currentIndex]['to']
        ) {
          continue
        }
        options.push({ value: '' + year, label: i, name: 'from' })
      }

      return (
        <SelectPlus
          className="as-edit-select-field education-entity-from"
          closeOnSelect={true}
          name="from"
          value={
            this.props.sectionWiseTextEditable[this.props.currentIndex]['from']
          }
          searchable={false}
          valueKey="value"
          arrowRenderer={() => {
            return null
          }}
          clearable={false}
          tabSelectsValue={false}
          placeholder={intl.formatMessage({ id: "aspire.education.fromYearPlaceholder", defaultMessage: "Start Year" })}
          aria-label={editModalAriaLabel(intl)['Education']['from_year']}
          options={options}
          onChange={this.handleDateChange}
        />
      )
    }

    if (entity == 'activities_and_societies') {
      let textAreaValue =
        this.props.sectionWiseTextEditable[this.props.currentIndex][
          'activities_and_societies'
        ] === false
          ? ''
          : this.props.sectionWiseTextEditable[this.props.currentIndex][
              'activities_and_societies'
            ]
      return (
        <div className="edit-education-description">
          <HighlightedTextarea
            name="activities_and_societies"
            label={intl.formatMessage({ id: "aspire.education.activitiesAndSocietiesLabel", defaultMessage: "Activities and Societies" })}
            highlight={this.highlightValues}
            value={textAreaValue}
            placeholder={this.placeholders['activities_and_societies']}
            onFocus={(e) => this.handleFocus('activities_and_societies', e)}
            onBlur={() => this.handleBlur('activities_and_societies')}
            onChange={this.handleChange}
            disabled={fieldDisabled}
          />
          <span className="education-chars-remain description">
            <span>
              {intl.formatMessage({ id: "aspire.education.activitiesAndSocietiesCharGuideline", defaultMessage: "The character count is maintained in accordance with LinkedIn guidelines" })}
            </span>
          </span>
          <span
            className="education-chars-remain"
            tabIndex={0}
            aria-label={this.activitiesAndSocietiesCharsRemaining}>
            <span>
              {charCountLimit['education']['activities_and_societies'] -
                this.activitiesAndSocietiesCharsRemaining}
            </span>
            /{charCountLimit['education']['activities_and_societies']}
          </span>
        </div>
      )
    }
  }

  getLabel(field, heading, emptyCondition) {
    const { savingChanges } = this.props
    let colorClass = null
    let fieldDisabled = false
    if (_.isEmpty(emptyCondition)) {
      colorClass = 'as-edit-input-field-label text-red'
    } else if (savingChanges) {
      colorClass = 'as-edit-input-field-label as-label-text-color'
      fieldDisabled = true
    } else if (this.state.focused[field]) {
      colorClass = 'as-edit-input-field-label as-focused-label-text-color'
    } else {
      colorClass = 'as-edit-input-field-label as-label-text-color'
    }

    return (
      <label className={colorClass}>
        {heading} <span className="text-red">*</span>
      </label>
    )
  }

  getSimpleLabel(field, heading) {
    const { savingChanges } = this.props
    let colorClass = null
    if (savingChanges) {
      colorClass = 'as-edit-input-field-label as-label-text-color'
    } else if (this.state.focused[field]) {
      colorClass = 'as-edit-input-field-label as-focused-label-text-color'
    } else {
      colorClass = 'as-edit-input-field-label as-label-text-color'
    }

    return <label className={colorClass}>{heading} </label>
  }

  getFromLabel() {
    const { sectionWiseTextEditable, currentIndex, savingChanges, intl } = this.props
    let colorClass = null
    if (
      _.isEmpty(sectionWiseTextEditable[currentIndex]['from']) &&
      !_.isEmpty(sectionWiseTextEditable[currentIndex]['to'])
    ) {
      colorClass = 'as-edit-input-field-label text-red'
    } else if (savingChanges) {
      colorClass = 'as-edit-input-field-label as-label-text-color'
    } else if (this.state.focused['from']) {
      colorClass = 'as-edit-input-field-label as-focused-label-text-color'
    } else {
      colorClass = 'as-edit-input-field-label as-label-text-color'
    }

    return (
      <label
        className={colorClass}
      >
        {intl.formatMessage({ id: "aspire.experience.labelFrom", defaultMessage: "From" })}{' '}
        <span
          className={classNames(
            'text-red',
            _.isEmpty(sectionWiseTextEditable[currentIndex]['from']) &&
              !_.isEmpty(sectionWiseTextEditable[currentIndex]['to'])
              ? ''
              : 'hidden'
          )}>
          *
        </span>
      </label>
    )
  }

  getToLabel() {
    const { sectionWiseTextEditable, currentIndex, savingChanges, intl } = this.props
    let colorClass = null
    if (
      !_.isEmpty(sectionWiseTextEditable[currentIndex]['from']) &&
      _.isEmpty(sectionWiseTextEditable[currentIndex]['to'])
    ) {
      colorClass = 'as-edit-input-field-label text-red'
    } else if (savingChanges) {
      colorClass = 'as-edit-input-field-label as-label-text-color'
    } else if (this.state.focused['to']) {
      colorClass = 'as-edit-input-field-label as-focused-label-text-color'
    } else {
      colorClass = 'as-edit-input-field-label as-label-text-color'
    }

    return (
      <label
        className={colorClass}
      >
        {intl.formatMessage({ id: "aspire.experience.labelTo", defaultMessage: "To" })}{' '}
        <span
          className={classNames(
            'text-red',
            !_.isEmpty(sectionWiseTextEditable[currentIndex]['from']) &&
              _.isEmpty(sectionWiseTextEditable[currentIndex]['to'])
              ? ''
              : 'hidden'
          )}>
          *
        </span>
      </label>
    )
  }

  getStaticSuggestion() {
    const { intl, user } = this.props;
    const { community } = user || {};
    if ( community === 'mofo' ) {
      return {
        writingTipsHeadline: intl.formatMessage({ id: "staticSuggestion.education.writingTipsHeadlineMofo" }),
        writingTipsText: intl.formatMessage({ id: "staticSuggestion.education.writingTipsTextMofo" }),
        tipsToGetStartedHeadline: intl.formatMessage({ id: "staticSuggestion.education.tipsToGetStartedHeadlineMofo" }),
        tipsToGetStartedText: intl.formatMessage({ id: "staticSuggestion.education.tipsToGetStartedTextMofo" }),
        exampleHeadline: intl.formatMessage({ id: "staticSuggestion.education.exampleHeadlineMofo" }),
        exampleText: intl.formatMessage({ id: "staticSuggestion.education.exampleTextMofo" })
      };
    }
    if ( community === 'iimmumbai' ) {
      return {
        writingTipsHeadline: intl.formatMessage({ id: "staticSuggestion.education.writingTipsHeadlineIIMMumbai" }),
        writingTipsText: intl.formatMessage({ id: "staticSuggestion.education.writingTipsTextIIMMumbai" }),
        tipsToGetStartedHeadline: intl.formatMessage({ id: "staticSuggestion.education.tipsToGetStartedHeadlineIIMMumbai" }),
        tipsToGetStartedText: intl.formatMessage({ id: "staticSuggestion.education.tipsToGetStartedTextIIMMumbai" }),
        examples: [
          { headline: intl.formatMessage({ id: "staticSuggestion.education.exampleHeadline1IIMMumbai" }), text: intl.formatMessage({ id: "staticSuggestion.education.exampleText1IIMMumbai" }) },
          { headline: intl.formatMessage({ id: "staticSuggestion.education.exampleHeadline2IIMMumbai" }), text: intl.formatMessage({ id: "staticSuggestion.education.exampleText2IIMMumbai" }) },
          { headline: intl.formatMessage({ id: "staticSuggestion.education.exampleHeadline3IIMMumbai" }), text: intl.formatMessage({ id: "staticSuggestion.education.exampleText3IIMMumbai" }) },
        ],
      };
    }
    return {
      writingTipsHeadline: intl.formatMessage({ id: "staticSuggestion.education.writingTipsHeadline" }),
      writingTipsText: intl.formatMessage({ id: "staticSuggestion.education.writingTipsText" }),
      tipsToGetStartedHeadline: intl.formatMessage({ id: "staticSuggestion.education.tipsToGetStartedHeadline" }),
      tipsToGetStartedText: intl.formatMessage({ id: "staticSuggestion.education.tipsToGetStartedText" }),
      exampleHeadline: intl.formatMessage({ id: "staticSuggestion.education.exampleHeadline" }),
      exampleText: intl.formatMessage({ id: "staticSuggestion.education.exampleText" })
    };
  }
  

  render() {
    const {
      savingChanges,
      currentIndex,
      newSubSection,
      hideEditModal,
      sectionWiseText,
      sectionWiseTextStatic,
      sectionWiseTextEditable,
      highlightEntityText,
      unhighlightAll,
      feedback,
      handleSaveChanges,
      handleUndoData,
      fetchId,
      addNewSection,
      showConfirmDeleteModal,
      showLogModal,
      intl,
      isRightNavToggle,
    } = this.props

    let undoButton = null
    let saveDisabled = true
    if (
      !(
        JSON.stringify(sectionWiseTextEditable[currentIndex]) ===
          JSON.stringify(sectionWiseTextStatic[currentIndex]) || savingChanges
      )
    ) {
      saveDisabled = false
      undoButton = (
        <button
          aria-label={editModalAriaLabel(intl)['reset']}
          className="btn btn-undo-changes"
          onClick={this.handleUndoClick}>
          {intl.formatMessage({ id: "aspire.education.resetButtonText", defaultMessage: "Reset" })}
        </button>
      )
    }

    let saveButton = (
      <SaveBtn
        savingChanges={savingChanges}
        saveDisabled={saveDisabled}
        handleSaveChanges={handleSaveChanges}
        intl={intl}
      />
    )

    let editOrAdd =
      !_.isUndefined(currentIndex) &&
      _.isString(currentIndex) &&
      currentIndex.substr(-4) === '_new'
        //           : 'Edit'
        ? intl.formatMessage({ id: "aspire.education.addModeText", defaultMessage: "Add" })
        : intl.formatMessage({ id: "aspire.education.editModeText", defaultMessage: "Edit" })

    // calculation for focused state and black overlay
    let blackOverlayClass = ''
    let editFocusedClass = ''

    let isAnyFieldFocused = false
    for (let index in this.state.focused) {
      if (this.state.focused[index]) {
        isAnyFieldFocused = true
        break
      }
    }

    if (savingChanges) {
      blackOverlayClass = 'as-edit-overlay-none'
      editFocusedClass = 'as-edit-focused-none'
    } else if (isAnyFieldFocused) {
      blackOverlayClass = 'as-edit-overlay-none as-edit-overlay-black'
      editFocusedClass = 'as-edit-focused-none as-edit-focused-black'
    } else {
      blackOverlayClass = 'as-edit-overlay-none'
      editFocusedClass = 'as-edit-focused-none'
    }

    let threeDotsBtn = (
      <ThreeDotsButton
        addNewSection={addNewSection}
        showConfirmDeleteModal={showConfirmDeleteModal}
        showLogModal={showLogModal}
        section="Education"
      />
    )

    if (newSubSection) {
      undoButton = null
      threeDotsBtn = null
    }

    const educationTips = this.getStaticSuggestion();

    return (
      <div className="as-edit-wrapper scroll-hidden">
        <Loader sectionName="Education" />
        <div className="as-edit-close-div">
          <a
            href="javascript:void(0);"
            aria-label={editModalAriaLabel(intl)['close']}
            onClick={this.handleCloseButton}
            className="icon-cross as-edit-close-btn modal-close-button"
            style={!isRightNavToggle ? { right: '17%' } : {}}
          />
        </div>
        <div className="as-edit-heading-wrapper">
          <div className="as-edit-heading" role="heading" aria-level="3">
            {intl.formatMessage({ id: "aspire.education.heading", defaultMessage: "Education" })}
          </div>
          <div className="as-edit-actions-div">
            <div className="as-edit-action-undo">{undoButton}</div>
            <div className="as-edit-action-save">{saveButton}</div>
            {threeDotsBtn}
          </div>
        </div>
        <div
          className="as-edit-container as-education-container"
          id="vertical-scroll">
          <div className={editFocusedClass}>
            <div className="as-edit-inputs-row row">
              <div className="as-edit-inputs-col as-education-text-col-left-6">
                {this.getLabel(
                  'school',
                  intl.formatMessage({ id: "aspire.education.schoolLabel", defaultMessage: "School" }),
                  sectionWiseTextEditable[currentIndex]['school']
                )}
                <div className="as-edit-input-field-wrapper">
                  {this.renderEntityText('school')}
                </div>
              </div>
              <div className="as-edit-inputs-col as-education-text-col-left-3">
                {this.getFromLabel()}
                <div
                  className="as-edit-select-field"
                  onFocus={(e) => this.handleFocus('from', e)}
                  onBlur={() => this.handleBlur('from')}>
                  {this.renderEntityText('from')}
                </div>
              </div>
              <div className="as-edit-inputs-col as-education-text-col-right-3">
                {this.getToLabel()}
                <div
                  className="as-edit-select-field"
                  onFocus={(e) => this.handleFocus('to', e)}
                  onBlur={() => this.handleBlur('to')}>
                  {this.renderEntityText('to')}
                </div>
              </div>
            </div>
            <div className="as-edit-inputs-row">
              <div className="as-edit-inputs-col as-education-text-col-left-6">
                {this.getSimpleLabel('degree', intl.formatMessage({ id: "aspire.education.degreeLabel", defaultMessage: "Degree" }))}
                <div className="as-edit-input-field-wrapper">
                  {this.renderEntityText('degree')}
                </div>
              </div>
              <div className="as-edit-inputs-col as-education-text-col-right-6">
                {this.getSimpleLabel('field_of_study', intl.formatMessage({ id: "aspire.education.fieldOfStudyLabel", defaultMessage: "Field of study" }))}
                <div className="as-edit-input-field-wrapper">
                  {this.renderEntityText('field_of_study')}
                </div>
              </div>
            </div>
            <div className="as-edit-inputs-row">
              <div className="as-edit-inputs-col">
                {this.getSimpleLabel(
                  'activities_and_societies',
                  intl.formatMessage({ id: "aspire.education.activitiesAndSocietiesLabel", defaultMessage: "Activities and Societies" })
                )}
                {this.renderEntityText('activities_and_societies')}
              </div>
            </div>
          </div>
        </div>
        <div className="as-edit-info-div">
          <div className="as-edit-suggestions-heading">
            <span
              tabIndex={0}
              aria-label= {educationTips.writingTipsHeadline}
            >
              {educationTips.writingTipsHeadline}
            </span>
          </div>
          <div className="as-edit-card-headline-education">
            {
              <div className="tips-section">
                <div style={{ whiteSpace: 'pre-line' }}>{educationTips.writingTipsText}</div>
                <div className="tips-heading">{educationTips.tipsToGetStartedHeadline}</div>
                <div style={{ whiteSpace: 'pre-line' }}>{educationTips.tipsToGetStartedText}</div>
                {!educationTips.examples ? (
                  <div>
                    <div className="tips-heading">{educationTips.exampleHeadline}</div>
                    <div style={{ whiteSpace: 'pre-line' }}>{educationTips.exampleText}</div>
                  </div>
                ) : null}
              </div>
            }
            {educationTips.examples ? (
              <div className="sample-carousel-wrapper">
                <button tabIndex={0} disabled={this.state.iimmumbaiExampleIndex === 0} onClick={() => this.setState({ iimmumbaiExampleIndex: this.state.iimmumbaiExampleIndex - 1 })} className="sample-carousel-btn sample-carousel-btn-prev">
                  <span className="arrow arrow-left" />
                </button>
                <div className="sample-carousel-card">
                  <div className="tips-heading">
                    {'Sample ' + (this.state.iimmumbaiExampleIndex + 1) + ' of ' + educationTips.examples.length + ' › ' + educationTips.examples[this.state.iimmumbaiExampleIndex].headline}
                  </div>
                  <div style={{ whiteSpace: 'pre-line' }}>{educationTips.examples[this.state.iimmumbaiExampleIndex].text}</div>
                </div>
                <button tabIndex={0} disabled={this.state.iimmumbaiExampleIndex === educationTips.examples.length - 1} onClick={() => this.setState({ iimmumbaiExampleIndex: this.state.iimmumbaiExampleIndex + 1 })} className="sample-carousel-btn sample-carousel-btn-next">
                  <span className="arrow arrow-right" />
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    )
  }

  componentDidUpdate(prevProps, prevState) {
    this.props.underlineEntitySpellError()
  }

  componentWillUnmount() {
    const { updateEditDynamicDataState, updateNewSamplesState } = this.props
    updateEditDynamicDataState({
      updateKeys: [
        ['fetchedContent'],
        ['fetchingContent'],
        ['dataContent'],
        ['errorContent'],
        ['fetchedSkills'],
        ['fetchingSkills'],
        ['dataSkills'],
        ['errorSkills'],
        ['fetchedLanguage'],
        ['fetchingLanguage'],
        ['dataLanguage'],
        ['errorLanguage'],
        ['fetchedImpact'],
        ['fetchingImpact'],
        ['dataImpact'],
        ['errorImpact'],
        ['fetchedRephraseWords'],
        ['fetchingRephraseWords'],
        ['dataRephraseWords'],
        ['errorRephraseWords'],
      ],
      data: {
        fetchedContent: false,
        fetchingContent: false,
        dataContent: null,
        errorContent: false,
        fetchedSkills: false,
        fetchingSkills: false,
        dataSkills: null,
        errorSkills: false,
        fetchedLanguage: false,
        fetchingLanguage: false,
        dataLanguage: null,
        errorLanguage: false,
        fetchedImpact: false,
        fetchingImpact: false,
        dataImpact: null,
        errorImpact: false,
        fetchedRephraseWords: false,
        fetchingRephraseWords: false,
        dataRephraseWords: null,
        errorRephraseWords: false,
      },
    })
    updateNewSamplesState({
      updateKeys: [['fetched'], ['fetching'], ['samples'], ['error']],
      data: { fetched: false, fetching: false, samples: null, error: false },
    })
  }
}

function mapStateToProps(state, ownProps) {
  return {
    savingChanges:
      !_.isEmpty(state.aspireFeedbackData.mini_loader_text) ||
      ownProps.uploadingEditedData,
    isRightNavToggle: state.editData.isRightNavToggle,
    user: state.user.data,
  }
}

export default connect(mapStateToProps, {
  updateEditDynamicDataState,
  updateNewSamplesState,
})(injectIntl(Education))
